// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1q-Qb","approved":"Status_approved__zNCZa","rejected":"Status_rejected__3g8oA","expired":"Status_expired__1kPgG","label":"Status_label__2iVRa"};